import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from 'preact/hooks'
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import SelectedFilters from "./SelectedFilters"

function ToggleMobileSidebarButton({ lableFor, selectedFiltersCount, className }) {
    return (
        <label
            for={lableFor}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-d-md-none ns-text-align-center ${className}`}
        >
            {/* <Icon name="filter" /> */}
            <span class="ns-filter-mobile-btn ns-filter-mobile-btn-icon">Filtrer</span>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
        </label>
    )
}

export default function Toolbar({ lableFor }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()
    const isMobile = window.innerWidth < 769;
    const [active, setActive] = useState(false)

    function handleSortChange(value){
        setSort(value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" 
        ? `${docCount} ${docCount === 1 ? 'produkt' : 'produkter'}` 
        : `'${query.query}' - ${docCount} ${docCount === 1 ? 'produkt' : 'produkter'}'`;

    const toggleActiveUpdated = () => {
        setActive(!active)
    }

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-column ns-d-none ns-d-md-flex ns-flex-wrap align-center ns-justify-content-between"
            // style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && ( */}
                <> 
                    <span
                        class="ns-page-results-title"
                        data-nosto-element="totalResults"
                    >
                        {totalSummary}
                    </span>
                    {!isMobile && (
                        <SelectedFilters />
                    )}
                </>
            {/* )} */}

            <div class="ns-mobile-toolbar ns-d-flex ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
                <ToggleMobileSidebarButton
                    lableFor={lableFor}
                    selectedFiltersCount={selectedFiltersCount}
                />
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                /> */}
                {isMobile && (
                        <>
                            <div class="ns-sidebar-menu ns-sort-menu-mobile" onClick={toggleActiveUpdated}>
                                <ul class="ns-sidebar-list ns-list-unstyled ns-p-0 ns-m-0">

                                <li class={`ns-sidebar-dropdown ns-not-facet-dropdown ns-sidebar-dropdown-sort-mobile ns-sorting-options ${active ? "ns-active" : ""}`}>
                                    <a
                                        class="ns-sidebar-facet-title ns-d-inline-block ns-w-100 ns-border-box ns-text-undecorated"
                                        href="javascript:void(0)"
                                        >
                                        <div class="ns-filter-mobile-btn">Sorter</div>
                                    </a>
                                    <div class="ns-sidebar-submenu ns-d-none">
                                        <ul class="ns-sort-list ns-list-unstyled">
                                            {options.map(option => (
                                                <li
                                                    class="ns-d-flex ns-align-items-center"
                                                    data-nosto-element="facet-setting"
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                        handleSortChange(option.value)
                                                        setActive(false)
                                                    }}
                                                >
                                                    <label class={`ns-checkbox ns-d-block`}>
                                                        <span class={`ns-count ns-d-inline-block ns-text-align-center ns-py-1 ns-px-1 ${activeSort === option.value ? "ns-font-bold" : ""}`}>
                                                            {option.label}
                                                        </span>
                                                        <input type="checkbox" checked={activeSort === option.value} />
                                                        <span class="ns-checkmark" />
                                                    </label>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                                </ul>
                            </div>
                        </>
                    )}
            </div>
                {isMobile && (
                    <SelectedFilters />
                )}
        </div>
    )
}
